import React from "react";
import { motion } from "framer-motion";
import MobileAppImage from "assets/images/mobile.png";
import MobileAppIcon from "assets/images/svg/icons.svg";
import google from "assets/images/google.svg";
import apple from "assets/images/apple.svg";

function MobileApp() {
  return (
    <div className="container-fluid get-application-bg-fluid position-relative bg-blackCoco pb-5 hw-100 d-flex align-items-center">
      <svg
        className="background-svg py-5 px-3"
        viewBox="0 0 1138 1138"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_f_16269_6149)">
          <circle
            cx="569"
            cy="569"
            r="263.706"
            stroke="#3BABA6"
            strokeWidth="3"
          />
          <circle
            cx="568.999"
            cy="569"
            r="389.566"
            stroke="#3BABA6"
            strokeWidth="3"
          />
          <circle
            cx="569"
            cy="569"
            r="561.5"
            stroke="#3BABA6"
            strokeWidth="3"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_16269_6149"
            x="0"
            y="0"
            width="1138"
            height="1138"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="3"
              result="effect1_foregroundBlur_16269_6149"
            />
          </filter>
        </defs>
      </svg>

      <div className="container get-application-bg text-center py-5">
        <div className="get-application-heading mt-md-0 pt-4">
          <h2 className="fs-64  l-h-0-9 custom-color-blue fw-300">GET FREE</h2>
          <p className="fs-80 l-h-0-9 hc fw-700 l-height">APPLICATION</p>
        </div>
        <div className="">
          <img
            className="img-fluid"
            src={MobileAppImage}
            alt=""
            style={{ height: "clamp(250px, 188.8715px + 18.8088vw, 550px)" }}
          />
        </div>
        <div className="stores-img d-flex justify-content-center align-items-center flex-wrap gap-3">
          <a
            href="https://play.google.com/store/apps/details?id=com.elevated_iron"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={google}
              alt=".."
              style={{ width: "clamp(100px, 80.2476px + 6.5392vw, 187px)" }}
            />
          </a>

          <a
            href="https://apps.apple.com/pk/app/elevated-iron/id6736553946"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={apple}
              alt=".."
              style={{ width: "clamp(100px, 80.2476px + 6.5392vw, 187px)" }}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default MobileApp;
